<template>
  <div class="step5_conatiner">
    <step5-modal v-if="modal_is_toggled" 
      @confirm="valide()" 
      @cancel="toggleModal(false)" 
      :order="fullorder" 
      :is-contract-validation-request="isContractValidationRequest"
      :buttonsDisabled="validationModalButtonsDisabled"
    ></step5-modal>

    <step5-cancel-modal v-if="cancel_modal_is_toggled" 
      @refuse="refuse()" 
      @cancel="toggleModal(false)"
      :buttonsDisabled="refusalModalButtonsDisabled"
    ></step5-cancel-modal>

    <div class="recap_container" v-if="isContractValidationRequest">
      <div class="recap_head_container">
        <h4>Récapitulatif</h4>
      </div>
      <div class="recap_infos_container">
        <div class="customer_infos">
          <h5><span v-if="customer.stored_in_erp">Client SAP</span><span v-else>Nouveau client</span> : {{customer.decoded_civility}} ({{customer.decoded_legal_form}}) {{customer.name}} </h5>
        </div>
        <!-- <div class="order_infos">
          <h5>Commande n° <strong>{{order.ihrez}}</strong> <em>({{ order.suborders[0].text }})</em></h5>
        </div> -->
        <div class="payment_infos">
          <h5>Statut du paiement : {{fullorder.decoded_payment_status}} <strong class="red_important" v-if="fullorder.payment_status != 'paid'">(Non encaissé)</strong></h5>
        </div>
        <div class="documents_infos">
          <h5>Documents : <strong v-if="all_documents_complete">complets</strong><strong v-else>incomplets</strong></h5>
        </div>
        <div v-if="isDomiciliationContractValidationRequest" class="digital_contract_infos">
          <h5>
            Signature électronique : 
            <strong v-if="digitalContract">{{ digitalContract.decoded_state }}</strong>
            <strong v-else>Aucun processus en cours</strong>
          </h5>

          <h5>
            Demande Avis Vérifiés : 
            <strong v-if="order.disable_avis_verifies" class="red_important">Désactivée</strong>
            <strong v-else>Activée</strong>
          </h5>
        </div>
      </div>
    </div>
    <div v-if="form !== null && form !== undefined && check_forms()" >
      <h5>Informations complémentaires requises</h5>
      <resource-form :model="form.model" :schema="form.schema" :triggers="form.triggers" :submit-button="false" :realtime-update="true" :initial-submit="true" @submit="saveAdditionalsDatas($event)">
      </resource-form>
    </div>
    <div style="display:inline-flex;" v-if="submitting">
      <div class="v-align-middle">
        <button class="btn btn-default btn-cons"
                :class="refuseButtonVariableClasses"
                @click="toggleModal(true, 'refuse')">
          Refuser
        </button>
      </div>
      <div class="v-align-middle">
        <button v-if="!isDisabledForTup"
                class="btn btn-complete btn-cons"
                :class="validateButtonVariableClasses"
                @click="toggleModal(true, 'validate')">
          Valider
        </button>
      </div>
    </div>
    <div v-else>
        Envoie des données au serveur en cours...
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex"
import Step5Modal from './Step5Modal'
import Step5CancelModal from './Step5CancelModal'
import ResourceForm from "components/Forms/ResourceForm"

export default {
  components:{
    Step5Modal,
    Step5CancelModal,
    ResourceForm
  },

  data () {
    return {
        demand_id: this.$route.params.id,
        debounced_navigation: null,
        submitting: true,
        modal_is_toggled: false,
        cancel_modal_is_toggled: false,
        additionals_datas: {},
        validationModalButtonsDisabled: false,
        refusalModalButtonsDisabled: false,
    }
  },

  created() {
    this.debounced_navigation = _.debounce(() => {this.$router.replace("/customer/" + this.current_treating_demand.demand.customer_id)}, 3500)
  },

  mounted () {
    this.forcedValidationRequestTreatmentForm(this.demand_id)
  },

  computed:{
    ...mapState('demands', ["current_treating_demand", "forms", "demands", "orders"]),

    all_documents_complete () {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)

      if(tf && tf.main_request && tf.main_request.request) {
          return tf.main_request.request.all_documents_complete
      }

      return false
    },

    order () {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
      if (tf && tf.main_request && tf.main_request.model_new_version && tf.main_request.model_new_version.order)
        return tf.main_request.model_new_version.order
      return false
    },

    customer() {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
      if (tf && tf.main_request && tf.main_request.model_new_version && tf.main_request.model_new_version.customer)
        return tf.main_request.model_new_version.customer
      return false
    },

    isContractValidationRequest() {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
      if (tf && tf.main_request && tf.main_request.request && tf.main_request.request.type)
        return tf.main_request.request.type.name === 'office-contract-validation' || tf.main_request.request.type.name === 'domiciliation-contract-validation'
      return false
    },

    isDomiciliationContractValidationRequest() {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)

      return this.isContractValidationRequest 
        && tf 
        && tf.main_request 
        && tf.main_request.request 
        && tf.main_request.request.type 
        && tf.main_request.request.type.name === 'domiciliation-contract-validation'
    },

    fullorder(){
      var tmp = _.find(this.orders, (order) => order.id == this.order.id)
      if (tmp)
        return tmp
      else {
        return false
      }
    },

    form() {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
      return tf != undefined ? (!_.isEmpty(tf.main_request.form) ? tf.main_request.form : null) : null
    },

    digitalContract() {
      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)

      if(tf && tf.main_request && tf.main_request.related_models && tf.main_request.related_models.digital_contract) {
          return tf.main_request.related_models.digital_contract
      }
      
      return null
    },

    refuseButtonVariableClasses() {
      return this.digitalContract && 'signed' == this.digitalContract.state ? 'disabled' : ''
    },
    
    validateButtonVariableClasses() {
      return this.digitalContract && 'signed' != this.digitalContract.state ? 'disabled' : ''
    },

    isDisabledForTup() {
      if (!this.isContractValidationRequest) {
        return false
      }

      var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)

      return tf.main_request.model_new_version.offer.distributed_product.agency.disabled_for_tup
    }
  },

  methods:{
    ...mapActions('demands', ["getValidationRequestById", "refuseValidation", "valideValidation","get_options", "forcedValidationRequestTreatmentForm"]),

    refuse () {
      this.refusalModalButtonsDisabled = true
      this.submitting = false

      this.refuseValidation(this.demand_id)
        .then(response => {
          this.toggleModal(false)
          this.goBackward()
        })
        .catch(error => {
          console.warn(error.response)
          // this.submitting = true
          this.getValidationRequestById(this.demand_id)
        })
        // .then(response => {
        //   this.refusalModalButtonsDisabled = false
        // })
    },

    check_forms()
    {
      // form.schmema.optional_fields.length == 0 && _.keys(form.schema).length > 1
      return (_.keys(this.form.schema).length > 1)
    },

    valide () {
      this.validationModalButtonsDisabled = true
      this.submitting = false
      
      var params = this.current_treating_demand.optional_params
      if (this.additionals_datas) {
        params = _.assign(this.current_treating_demand.optional_params, this.additionals_datas)
      }

      this.valideValidation({ validation_request_id: this.demand_id, others: params })
        .then(response => {
          this.toggleModal(false)
          this.goBackward()
        })
        .catch(error => {
          console.warn(error.response)
          // this.submitting = true
          this.getValidationRequestById(this.demand_id)
        })
        // .then(response => {
        //   this.validationModalButtonsDisabled = false
        // })
    },

    goBackward() {
      this.debounced_navigation()
    },

    toggleModal(event, modal) {
      if (event) {
        if (modal === 'validate') this.modal_is_toggled = true
        else this.cancel_modal_is_toggled = true
      }
      else {
        this.modal_is_toggled = false
        this.cancel_modal_is_toggled = false
      }
    },

    saveAdditionalsDatas(event)
    {
      if (event.hasOwnProperty("data"))
        this.additionals_datas = event.data
      else {
        this.additionals_datas = event
      }
    },
  }
}

</script>
<style scoped>

.recap_container {
  border: solid 1px lightgrey;
  padding: 15px;
  margin-bottom: 15px;
}

.recap_head_container {
  border-bottom: solid 1px lightgray;
}

.red_important {
  color:red;
}

.btn-complete.disabled, .btn-complete[disabled] {
  color: #fb557a;
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Step5.vue